import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const rowsApi = createApi({
  reducerPath: 'rowsQueries',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://mock.fitradio.com/api2.0',
  }),
  endpoints: (builder) => ({
    getMix: builder.query({
      query: ({ rowData: { api_url } }) => api_url.replace('https://mock.fitradio.com/api2.0', ''),
    }),
    getMixById: builder.query({
      query: ({ id }) =>
        `/music/getmixbyid/id/${id}/token/a0caa92c880f87ddab3924243bc14068/client/fitradio/protocol/HLS`,
    }),
    getRows: builder.query({
      query: () => `/musicrow/getlist/version/2.0/token/a0caa92c880f87ddab3924243bc14068`,
    }),
  }),
});

export const { useGetRowsQuery, useGetMixQuery, useGetMixByIdQuery } = rowsApi;
